// environment variables
export const BACKEND_BASE_URL=process.env.VUE_APP_BACKEND_BASE_URL
export const BACKEND_P_BASE_URL=process.env.VUE_APP_BACKEND_P_BASE_URL
export const BASE_URL=process.env.VUE_APP_BASE_URL